export const images = [
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-brandywine-global.png',
    altText: 'Alt image text1',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-clarion-partners.png',
    altText: 'Alt image text2',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-clearbridge-investments.png',
    altText: 'Alt image text3',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-martin-currie.png',
    altText: 'Alt image text4',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-qs-investors.png',
    altText: 'Alt image text5',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-royce.png',
    altText: 'Alt image text6',
    link: '',
  },
  {
    src:
      'https://frkngcdev.z22.web.core.windows.net/storybook/assets/images/SIMLogos/logo-western-asset.png',
    altText: 'Alt image text7',
    link: '',
  },
];
